<template>
  <div>
    <!-- Footer Section Start -->
    <footer>
      <!-- Footer Area Start -->
      <section class="footer-Content">
        <div class="container wow fadeInDown" data-wow-duration="1000ms" data-wow-delay="300ms">
          <h3 class="logo-title">Basic</h3>
          <div class="row">
            <div class="col-md-4 col-sm-6 col-xs-12">
              <div class="widget">
                <div class="textwidget">
                  <p>Lorem ipsum dolor sit amet, con sectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore.Lorem ipsum dolor sit amet, con sectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore.</p>
                </div>
                <form class="subscribe-box">
                  <input placeholder="Your email" type="text">
                  <input class="btn-system" value="Send" type="submit">
                </form>
              </div>
            </div>
            <div class="col-md-2 col-sm-6 col-xs-12">
              <div class="widget">
                <h3 class="block-title">Links</h3>
                <ul class="menu">
                  <li>
                    <a href="#">About Us</a>
                  </li>
                  <li>
                    <a href="#">Services</a>
                  </li>
                  <li>
                    <a href="#">Works</a>
                  </li>
                  <li>
                    <a href="#">Pricing</a>
                  </li>
                  <li>
                    <a href="#">Contact</a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-md-2 col-sm-6 col-xs-12">
              <div class="widget">
                <h3 class="block-title">Services</h3>
                <ul class="menu">
                  <li>
                    <a href="#">Web Design</a>
                  </li>
                  <li>
                    <a href="#">Graphics Design</a>
                  </li>
                  <li>
                    <a href="#">Branding</a>
                  </li>
                  <li>
                    <a href="#">UX Consulting</a>
                  </li>
                  <li>
                    <a href="#">Mobile Apps</a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-md-4 col-sm-6 col-xs-12">
              <div class="widget">
                <h3 class="block-title">Flicker Gallery</h3>
                <ul class="featured-list">
                  <li>
                    <a href="#"><img alt="" src="@/assets/img/featured/img1.jpg"></a>
                  </li>
                  <li>
                    <a href="#"><img alt="" src="@/assets/img/featured/img2.jpg"></a>
                  </li>
                  <li>
                    <a href="#"><img alt="" src="@/assets/img/featured/img3.jpg"></a>
                  </li>
                  <li>
                    <a href="#"><img alt="" src="@/assets/img/featured/img4.jpg"></a>
                  </li>
                  <li>
                    <a href="#"><img alt="" src="@/assets/img/featured/img5.jpg"></a>
                  </li>
                  <li>
                    <a href="#"><img alt="" src="@/assets/img/featured/img6.jpg"></a>
                  </li>
                  <li>
                    <a href="#"><img alt="" src="@/assets/img/featured/img7.jpg"></a>
                  </li>
                  <li>
                    <a href="#"><img alt="" src="@/assets/img/featured/img8.jpg"></a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- Footer area End -->

      <!-- Copyright Start  -->
      <div id="copyright">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <div class="site-info pull-left wow fadeInLeft" data-wow-duration="1000ms" data-wow-delay="300ms">
                <p>Template by
                  <a rel="nofollow" href="https://graygrids.com/">GrayGrids</a>
                </p>
              </div>
              <div class="bottom-social-icons social-icon pull-right wow fadeInRight" data-wow-duration="1000ms" data-wow-delay="300ms">
                <a class="twitter" href="#">
                  <font-awesome-icon :icon="['fab', 'twitter']" />
                </a>
                <a class="facebook" href="#">
                  <font-awesome-icon :icon="['fab', 'facebook-f']" />
                </a>
                <a class="google-plus" href="#">
                  <font-awesome-icon :icon="['fab', 'google']" />
                </a>
                <a class="linkedin" href="#">
                  <font-awesome-icon :icon="['fab', 'linkedin-in']" />
                </a>
                <a class="dribble" href="#">
                  <font-awesome-icon :icon="['fab', 'dribbble']" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Copyright End -->

    </footer>
    <!-- Footer Section End -->
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  mounted () {
  },
  methods: {
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.pull-right {
  float: right;
}
.pull-left {
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue